// Shared Chakra `sx` styles for Prismic rich text rendered via asHTML() + dangerouslySetInnerHTML.
// Colors match the website's slice styling (antaia-website src/slices/*).
const GREEN = "#5A8A1A";
const HEADING = "#0E3137";

export const richTextSx = {
  h1: { fontSize: "24px", fontWeight: "700", color: HEADING, mt: 6, mb: 4 },
  h2: { fontSize: "24px", fontWeight: "700", color: HEADING, mt: 6, mb: 4 },
  h3: { fontSize: "24px", fontWeight: "700", color: GREEN, mt: 5, mb: 3 },
  h4: { fontSize: "24px", fontWeight: "600", color: HEADING, mt: 4, mb: 3 },
  p: { fontSize: "body.m", color: "gray.600", mb: 4, lineHeight: "1.7" },
  strong: { fontWeight: "600", color: HEADING },
  em: { color: GREEN, fontWeight: "500", fontStyle: "normal" },
  ul: { pl: 5, mb: 4 },
  ol: { pl: 5, mb: 4 },
  li: { fontSize: "body.m", color: "gray.700", mb: 2 },
};

// Overrides richTextSx's plain browser-bullet <ul>/<li> with a green
// circle-checkmark marker (CSS-drawn via ::before, so no extra icon markup is
// needed inside dangerouslySetInnerHTML) — matches the website's DualColumnContent
// slice list treatment. Spread on top of richTextSx: `{ ...richTextSx, ...checklistSx }`.
// List item text itself is normal weight/gray — list content is always authored as
// "**Label** — description" (a bold <strong> lead-in followed by plain text), so
// only that <strong> span should be bold/dark, not the whole line.
export const checklistSx = {
  ul: { listStyle: "none", pl: 0, mb: 4 },
  li: {
    position: "relative",
    fontSize: "body.m",
    fontWeight: "400",
    color: "gray.600",
    pl: "28px",
    mb: 3,
    "&::before": {
      content: '"✓"',
      position: "absolute",
      left: 0,
      top: "2px",
      width: "18px",
      height: "18px",
      borderRadius: "full",
      border: "1.5px solid",
      borderColor: GREEN,
      color: GREEN,
      fontSize: "11px",
      fontWeight: "700",
      lineHeight: "16px",
      textAlign: "center",
    },
  },
};
